function toggleNewAddressButton(){
    const SELECTOR_BUTTON = ".address-new-toggle"
    const SELECTOR_ADDRESS_HEADER = ".account-header";

    const buttons = window.document.querySelectorAll(SELECTOR_BUTTON);
    const header = window.document.querySelector(SELECTOR_ADDRESS_HEADER);

    if (buttons.length < 1 || !header) return;

    buttons.forEach(button => {
        button.addEventListener('click',function(){
            if (header.contains(this)) this.classList.toggle('hide');
            else{
                const windowsWidth = window.innerWidth;
                let headerButton;

                if (windowsWidth <= 750)
                    headerButton = header.querySelector('button.only-mobile')
                else
                    headerButton = header.querySelector('button.hide-mobile')

                headerButton?.classList.toggle('hide')
            }
        })
    })
}

window.addEventListener('load',toggleNewAddressButton);